import { Card, CardBody, Col } from "reactstrap";
import FormCard from "./FormCard";
import { ValidationFormTitle } from "../../../../../../constants";
import { ValidationFormSubTitle } from "../../../../../../data/formsAndTable/forms/FormControls";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const ValidationForm = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={ValidationFormTitle} span={ValidationFormSubTitle} />
        <CardBody>
          <FormCard />
        </CardBody>
      </Card>
    </Col>
  );
};
export default ValidationForm;
